module.exports = __webpack_public_path__ + "img/1717382717954-WhatsApp Image 2024-06-03 at 10.45.05.jpeg.c9a2e05e.webp";